module.exports = __webpack_public_path__ + "static/mobile-reporters-hdr-936610b2e6ba42aac4f0196e8ecd3a57.png";